const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onShowAllClick: {
      to: "/"
    },
    onModelClick: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
